const data = (state = {
    pages: null
}, action) => {

    switch (action.type) {

        case 'PAGE_RECEIVED':
            return {
                ...state,
                pages: {
                    ...state.pages,
                    [action.page.slug]: action.page
                }
            }

        default:
            return state
    }
}

export default data


// WEBPACK FOOTER //
// ./src/reducers/content.js